import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Mail } from "lucide-react";
import { authApi } from "../../services/api";

export default function ForgotPassword() {
  const logoUrl = `${process.env.PUBLIC_URL}/logo.png`;
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email) { setError("Email is required."); return; }
    setLoading(true);
    setError("");
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell auth-shell-centered">
      <div className="auth-card auth-card-solo">
        <div className="auth-brand">
          <span className="auth-logo">
            <img src={logoUrl} alt="Lucky Pool logo" className="auth-logo-image" />
          </span>
          {/* <strong>Lucky Pool</strong> */}
        </div>

        {sent ? (
          <div className="auth-sent-state">
            <span className="auth-sent-icon"><Mail size={32} /></span>
            <h1>Check your inbox</h1>
            <p className="auth-sub">A reset link has been sent to <strong>{email}</strong>. It expires in 15 minutes.</p>
            <Link to="/login" className="auth-submit" style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
              Back to Sign In
            </Link>
          </div>
        ) : (
          <>
            <div className="auth-card-header">
              <h1>Reset password</h1>
              <p className="auth-sub">Enter your email and we'll send a secure reset link.</p>
            </div>

            {error && <div className="auth-error" role="alert">{error}</div>}

            <form onSubmit={handleSubmit} noValidate>
              <div className="auth-field">
                <label htmlFor="reset-email">Email address</label>
                <input
                  id="reset-email" type="email" required
                  value={email} onChange={(e) => { setEmail(e.target.value); setError(""); }}
                  placeholder="you@example.com"
                />
              </div>
              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? <span className="auth-spinner" /> : "Send Reset Link"}
              </button>
            </form>
          </>
        )}

        {!sent && (
          <p className="auth-switch" style={{ marginTop: 16 }}>
            <Link to="/login">← Back to Sign In</Link>
          </p>
        )}
      </div>
    </div>
  );
}
